import React, { createContext, useContext, useRef, useMemo } from "react";
import PropTypes from "prop-types";

// Crea el contexto
const RefsContext = createContext(null);

// Proveedor del contexto
export function RefsProvider({ children }) {
  const workOrderUserAssignedRef = useRef(null);
  const alertDialogRef = useRef(null);

  const value = useMemo(
    () => ({
      workOrderUserAssignedRef,
      alertDialogRef,
    }),
    [workOrderUserAssignedRef, alertDialogRef]
  );

  return <RefsContext.Provider value={value}>{children}</RefsContext.Provider>;
}

// Hook para acceder al valor del contexto
export function useRefs() {
  return useContext(RefsContext);
}

RefsProvider.propTypes = {
  children: PropTypes.any,
};
